<template>
    <div class="order_detial" v-loading="loading">
        <div class="order_titles">查看订单详情</div>
        <div class="order_derial_box">
            <div class="order_type">
                <div class="type_item" v-for="(item, index) in type_list" :key="index" :class="{ tyle_ac: tyle_ac >= index }">
                    <div class="type_icons">
                        <div class="lefts">
                            <div class="borders" v-if="index != 0"></div>
                        </div>
                        <div class="consts">
                            <div class="icons">{{ index + 1 }}</div>
                        </div>
                        <div class="rigths">
                            <div class="borders" v-if="index != (type_list.length - 1)"></div>
                        </div>
                    </div>
                    <div class="type_title">{{ item.title }}</div>
                    <div class="type_time">{{ item.times }}</div>
                </div>
            </div>
            <div class="order_info">
                <div class="info_top">
                    <div class="texts">
                        订单信息
                    </div>
                </div>
                <div class="info_bom">
                    <div class="text_flex">
                        <div class="text1">联系人信息</div>
                        <div class="text2">支付及支付方式</div>
                    </div>
                    <div class="text_flex text_flex2">
                        <div class="text3">
                            <div class="text3_1">联系人：</div>
                            <div class="text3_2">{{ order_detial.custom_name }}</div>
                        </div>
                        <div class="text4">
                            <div class="text4_1">支付方式：</div>
                            <div class="text4_2">{{ pay_obj[(order_detial.pay_info||{}).pay_type]||'' }}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">联系电话：</div>
                            <div class="text3_2">{{ order_detial.custom_phone }}</div>
                        </div>
                        <div class="text4">
                            <div class="text4_1">下单时间：</div>
                            <div class="text4_2">{{ order_detial.created_at }}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">电子邮箱：</div>
                            <div class="text3_2">{{ order_detial.email }}</div>
                        </div>
                        <div class="text4">
                            <div class="text4_1">发票：</div>
                            <div class="text4_2">
                                {{order_detial.kaipiao_file?'已开票':order_detial.if_kaipiao?'不需要开票':'需要开票'}}

                                
                            </div>
                            <!--  -->
                        </div>
                    </div>
                </div>

            </div>
            <div class="order_item">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ order_detial.created_at }} </div>
                        <div class="order_no">订单号：{{ order_detial.order_sn }}</div>
                    </div>
                </div>
                <div class="order_info_shop">
                    <div class="shop_list">
                        <div class="shop_item">
                            <div class="shop_left">
                                <div class="shop_img">
                                    <img src="@/assets/img/index/legal/bg1.png" alt="">
                                </div>
                                <div class="shop_title">{{ (order_detial.pro||{}).title }}</div>
                            </div>
                            <div class="shop_right">
                                <div class="shop_price1">{{(order_detial.pro||{}).price}}元</div>
                                <div class="shop_num">X1</div>
                                <div class="shop_price2">{{(order_detial.pro||{}).price}}元</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_price">
                        <div class="btns_lefts">
                            <div class="text1">
                                共
                                <span>1</span>
                                个商品
                            </div>
                            <div class="text2">
                                合计金额
                                <span>{{ order_detial.price }}</span>
                                元
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>

            <div class="order_info" v-if="carry_order.id">
                <div class="info_top">
                    <div class="texts">
                        携带订单
                    </div>
                </div>
                <div class="info_bom">
                    <div class="text_flex">
                        <div class="text1">
                            {{  carry_order.order_sn}}
                            <el-button type="text" @click="$router.push('/user_order/order_detial?id='+carry_order.id)">查看订单详情</el-button>
                        </div>
                    </div>
                    
                    <div class="text_flex text_flex2">
                        <div class="text3">
                            <div class="text3_1">案件类型：</div>
                            <div class="text3_2">{{minx_get_case_type(carry_order.case_type)}}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">申请人类型：</div>
                            <div class="text3_2">{{ minx_get_custom_type(carry_order.custom_type)}}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">联系人姓名：</div>
                            <div class="text3_2">{{ carry_order.custom_name }}</div>
                        </div>
                    </div>


                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">手机号：</div>
                            <div class="text3_2">{{ carry_order.custom_phone }}</div>
                        </div>
                    </div>
                    <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">所在地区：</div>
                            <div class="text3_2">  {{minx_get_province_cita_area(carry_order.province,carry_order.city,carry_order.area)  }}</div>
                        </div>
                    </div>
                     <div class="text_flex">
                        <div class="text3">
                            <div class="text3_1">电子邮箱：</div>
                            <div class="text3_2">{{ order_detial.email }}</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="order_btns">
                <!-- <div class="btns1">补充资料</div> -->
                <!-- <div class="btns1">下载发票</div> -->
                <div class="btns2" @click="handle_qx" v-if="order_detial.status==10">取消订单</div>
                <div class="btns2" @click="handle_qx" v-if="order_detial.status==20">取消订单</div>
                <div class="btns2" @click="handle_end" v-if="order_detial.status==30">确认完成</div>
                <div class="btns2" @click="handle_pj" v-if="order_detial.status==40">写评价</div>
            </div>
        </div>
        <user_order_qx ref="user_order_qx" @handle_qx_end="get_detial"></user_order_qx>
    </div>
</template>
<script>
import { mapState } from 'vuex'

import user_order_qx from '@/components/user_order/user_order_qx.vue'//律所


export default {
    components: {
        user_order_qx,

    },
    name: "homes",
    data() {
        return {
            loading: false,
            tyle_ac: 0,
            order_detial:[],//
            carry_order:{},
            type_list: [
                {
                    title: '购买时间',
                    times: '2022-11-20'
                },
                {
                    title: '服务中',
                    times: '2022-11-21'
                },
                {
                    title: '服务完成',
                    times: '2022-11-22'
                }
            ],
            pay_obj:{
                1:'微信支付',
                2:'支付宝支付',
                3:'网银支付',
                4:'线下转款',
                5:'佣金支付',
            }


        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {
       $route: {
            handler(newVal, oldVal) {
                this.get_detial()
            },
            immediate: true,
            deep: true
        },
    },
    created() {
    },
    methods: {
        get_detial(){
            this.loading = true
            this.$api("myOrderDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data
                    this.carry_order=res.data.carry_order
                    this.type_list= [
                        {
                            title: '购买时间',
                            times: res.data.created_at
                        },
                        {
                            title: '服务中',
                            times: res.data.receive_time
                        },
                        {
                            title: '服务完成',
                            times: res.data.finish_time
                        }
                    ]
                    if(res.data.receive_time){
                        this.tyle_ac=1
                    }
                    if(res.data.finish_time){
                        this.tyle_ac=2
                    }

                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_qx(){
            console.log('取消')
            this.$refs.user_order_qx.handle_open()
        },
        handle_end(){
            this.$confirm('确定完成服务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handle_end2()
            }).catch(() => {
               
            });
        },
        handle_end2(){
            this.loading = true
            this.$api("finishOrder", {
               id:this.$route.query.id
             
			}, "post").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    alertSucc('服务完成')
                   this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_pj(){
            console.log('评价')
            this.$router.push({
                path:'/user_order/order_pj',
                query:{
                    id:this.$route.query.id
                }
            })
        },



    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_derial_box {
        margin-top: 24px;
        padding: 24px;
        background: #FFFFFF;

        .order_type {
            display: flex;
            // align-items: top;
            justify-content: center;

            .type_item {
                .type_icons {
                    display: flex;
                    align-items: top;

                    .lefts {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;

                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            ;
                            border-radius: 0px 0px 0px 0px;
                        }

                    }

                    .consts {
                        .icons {
                            width: 44px;
                            height: 44px;
                            background: rgba(55, 124, 253, 0.06);
                            border-radius: 50%;
                            text-align: center;
                            line-height: 44px;
                            font-weight: 400;
                            font-size: 20px;
                            color: #999999;
                        }
                    }

                    .rigths {
                        width: 148px;
                        height: 44px;
                        display: flex;
                        align-items: center;

                        .borders {
                            width: 148px;
                            height: 2px;
                            // background: #377CFD;
                            background: #F5F5F5;
                            ;
                            border-radius: 0px 0px 0px 0px;
                        }
                    }
                }

                .type_title {
                    text-align: center;
                    padding-top: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #000000;
                }

                .type_time {
                    text-align: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #808080;
                    padding-top: 8px;

                }

            }

            .tyle_ac {
                .type_icons {
                    .lefts {
                        .borders {
                            background: #377CFD;
                        }
                    }

                    .consts {
                        .icons {
                            background: #377CFD;
                            color: #FFFFFF;
                        }
                    }

                    .rigths {
                        .borders {
                            background: #377CFD;
                        }
                    }
                }

                .type_title {}

                .type_time {}
            }
        }

        .order_info {
            width: 1132px;
            min-height: 218px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;
            margin-top: 56px;

            .info_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;

                .texts {
                    // width: 1132px;

                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                }

            }

            .info_bom {
                padding: 24px;

                .text_flex2 {
                    margin-top: 24px;
                }

                .text_flex {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 8px;

                    .text1 {
                        width: 500px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;

                    }

                    .text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }

                    .text3 {
                        width: 500px;
                        display: flex;
                        align-items: center;

                        .text3_1 {
                            // width: 70px;
                            text-align: left;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .text3_2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-left: 10px;
                        }
                    }

                    .text4 {
                        display: flex;
                        align-items: center;

                        .text4_1 {
                            width: 70px;
                            text-align: left;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .text4_2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-left: 10px;

                        }
                    }
                }
            }

        }

        .order_item {
            // width: 1132px;
            min-height: 260px;
            margin-top: 24px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;

            .item_titles {
                // width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;

                .order_lefts {
                    display: flex;
                    align-items: center;

                    .order_time {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-right: 20px;
                    }

                    .order_no {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    }
                }

                .order_rights {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }

            .order_info_shop {
                padding: 0 24px;
                padding-top: 24px;

                .shop_list {

                    border-bottom: 1px solid #E5E5E5;

                    .shop_item {
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .shop_left {
                            display: flex;
                            align-items: center;

                            .shop_img {
                                width: 104px;
                                height: 104px;

                                img {
                                    width: 104px;
                                    height: 104px;
                                }
                            }

                            .shop_title {
                                padding-left: 24px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }
                        }

                        .shop_right {
                            display: flex;
                            align-items: center;

                            .shop_price1 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;

                            }

                            .shop_num {
                                width: 100px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }

                            .shop_price2 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;


                            }
                        }
                    }
                }

                .order_price {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    height: 64px;

                    .btns_lefts {
                        display: flex;
                        align-items: center;

                        .text1 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;

                            span {
                                color: #377CFD;
                                font-weight: bold;
                            }
                        }

                        .text2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            margin-left: 20px;

                            span {
                                color: #377CFD;
                                font-weight: bold;

                            }
                        }
                    }

                
                }


            }
        }
        .order_btns{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: 32px;
            .btns1{
                width: 116px;
                height: 36px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                text-align: center;
                line-height: 36px;
                cursor: pointer;
                margin-left: 10px;

            }
            .btns2{
                width: 116px;
                height: 36px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 36px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #F5F5F5;
                margin-left: 10px;
            }
        }

    }



}
</style>